// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"a3891ed5","451":"36165a21","453":"01fbda6e","455":"afd50962","592":"a487e923","977":"796e715b"}[chunkId] + ".chunk.js";
};